import { FileUploadResult, Options, uploadFile } from './file.upload';

const defaultOptions: Options = {
    maxFiles: 1,
    // The type is defined as boolean for some reason. Looks like the limits are actually not implemented.
    maxFileSize: (10 * 1000 * 1000) as unknown as boolean,
    chunkSize: 1000 * 1000,
    allowedExtensions: '.jpeg,.jpg,.gif,.png',
    method: 'octet',
    uploadMethod: 'PUT',
};

export interface ImageUploadResult extends FileUploadResult {
    width: number;
    height: number;
}

export function uploadImage(serverUrl: string, storage: string, options = defaultOptions) {
    return uploadFile<ImageUploadResult>({ serverUrl, storage, options });
}
